import { faLayerGroup } from "@fortawesome/pro-regular-svg-icons";
import { faHistory, faRunning } from "@fortawesome/pro-solid-svg-icons";

import { Icon } from "../Icon/Icon";
import { CanvasIcon } from "../icons";
import { Category, FilePickerConfig } from "./types";

export const TABS_CONTENT = [
  {
    icon: <Icon size="large" icon={faHistory} className="fa fa-fw" />,
    label: "Recent",
    value: "recent",
  },
  {
    icon: <Icon size="large" icon={faLayerGroup} className="fa fa-fw" />,
    label: "Drive",
    value: "drive",
  },
  {
    icon: <CanvasIcon style={{ width: 18, height: 18 }} />,
    label: "Sketch",
    value: "sketch",
  },
  {
    icon: <Icon size="large" icon={faRunning} className="fa fa-fw" />,
    label: "Poses",
    value: "pose",
  },
];

export const FILE_PICKER_CONFIG_COMMON: FilePickerConfig = {
  maxFiles: 10,
  maxVisibleFiles: 4,
  filesLayout: "grid",
  categories: ["recent", "drive"] as Category[],
  accept: {
    "image/jpeg": [".jpg", ".jpeg"],
    "image/png": [".png"],
    "video/mp4": [".mp4"],
  },
};
